import { Language } from './types';

export const defaultLang = 'en';
export const supportedLangs: Language[] = [
  defaultLang,
  'fr',
  'de',
  'pt',
  'es',
  'zh',
  'ja',
];
